module.exports = __webpack_public_path__ + "670e791a29a3c63121460181a5ee232e.svg";